export default __webpack_public_path__ + "static/media/downloadImg.63d24235.png";